import { render, staticRenderFns } from "./StudentLessonRecordsModal.vue?vue&type=template&id=07e6528a&"
import script from "./StudentLessonRecordsModal.vue?vue&type=script&lang=js&"
export * from "./StudentLessonRecordsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports